import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/auth/store";
import Roles from "./modules/roles/store";
import Modules from "./modules/rolemodules/store";
import Permissions from "./modules/permissions/store";
import Users from "./modules/users/store";
import UserRoles from "./modules/userroles/store";
import userProfile from "./modules/userprofile/store";
import products from "./modules/products/store";
import suppliers from "./modules/suppliers/store";
import consignees from "./modules/consignees/store";
import stocks from "./modules/stocks/store";
import transporters from "./modules/transporters/store";
import trucks from "./modules/trucks/store";
import trips from "./modules/trips/store";
import payments from "./modules/payments/store"
import accounttypes from "./modules/accounttypes/store";
import pettycashes from "./modules/pettycashes/store";
import purchaseorders from "./modules/purchaseorders/store";
import goodsreceiving from "./modules/goodsreceiving/store";
import purchases from "./modules/purchases/store";
import sales from "./modules/sales/store";
import expenses from "./modules/expenses/store";
import reports from "./modules/reports/store";
import labours from "./modules/labours/store";
import oils from "./modules/oils/store";
import interchanges from "./modules/interchanges/store";
import employees from "./modules/employees/store";
import attendances from "./modules/attendances/store";
import invoices from "./modules/invoices/store";
import numberlesslabours from "./modules/numberlesslabours/store";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    Roles,
    Modules,
    Permissions,
    Users,
    UserRoles,
    userProfile,
    products,
    suppliers,
    consignees,
    stocks,
    transporters,
    trucks,
    trips,
    payments,
    accounttypes,
    pettycashes,
    purchaseorders,
    goodsreceiving,
    purchases,
    sales,
    expenses,
    reports,
    labours,
    oils,
    interchanges,
    employees,
    attendances,
    invoices,
    numberlesslabours
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js